import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { HiChevronDown, HiChevronUp } from 'react-icons/hi';
import { FiFolder } from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import { frontendNotification } from '../../Notification';
import { SidebarItem, SidebarItemITF } from '../types';

import { getPathURL } from '../../../utils/helpers';
import * as s from './styles';
import Tooltip from '../../Tooltip';
import { isSafeItemUrl } from '../Customization/layout';

export const RenderItems = ({
  item,
  isSidebarOpen,
  closeSidebar,
  forceShowSubItems,
  depth = 0
}: SidebarItemITF) => {
  const [showSubnav, setShowSubnav] = useState(false);

  const toggleShowSubnav = () => setShowSubnav(!showSubnav);

  const navigate = useNavigate();
  const { t } = useTranslation();

  // Quando forceShowSubItems é true (durante busca), mostrar subitens automaticamente
  useEffect(() => {
    if (forceShowSubItems && item.sidebarSubItems && item.sidebarSubItems.length > 0) {
      setShowSubnav(true);
    } else if (!forceShowSubItems) {
      // Fechar quando a busca é limpa (opcional - pode remover se quiser manter aberto)
      // setShowSubnav(false);
    }
  }, [forceShowSubItems, item.sidebarSubItems]);

  const handleClick = (menu: SidebarItem) => {
    if (menu.disabled) {
      return frontendNotification({
        message: t(menu.disabled),
        type: 'warning',
      });
    }

    if (menu.sidebarSubItems) {
      return toggleShowSubnav();
    }

    if (menu.externalUrl && isSafeItemUrl(menu.externalUrl)) {
      window.location.assign(menu.externalUrl);
      return null;
    }

    if (menu.path && !menu.disabled) {
      if (window.screen.width < 900) {
        closeSidebar();
      }
      return navigate(menu.path);
    }

    return null;
  };

  const handleArrowitem = () => {
    if (item.sidebarSubItems && showSubnav) {
      return <HiChevronUp />;
    }
    if (item.sidebarSubItems) {
      return <HiChevronDown />;
    }
    return null;
  };

  const visibleSubItems = item.sidebarSubItems?.filter(subItem => subItem.show) || [];

  const Container = depth ? s.SidebarSubItemContainer : s.SidebarItemContainer;
  const title = item.customLabel ? item.title : t(item.title);
  const Icon = item.icon || (item.customLabel ? FiFolder : undefined);

  return (
    <>
      <Tooltip title={isSidebarOpen ? '' : title}>
        <Container
          onClick={() => handleClick(item)}
          isSidebarOpen={isSidebarOpen}
          isPathSelected={item.path === getPathURL()}
        >
          {Icon && (
            <div id="sidebar-item-icon">
              <Icon />
            </div>
          )}
          <div id="sidebar-item-title">
            <p>{title}</p>
          </div>

          <div id="sidebar-item-arrow">{handleArrowitem()}</div>
        </Container>
      </Tooltip>

      {showSubnav && visibleSubItems.length > 0 && (
        <s.SubItemsContainer isOpen={showSubnav}>
          {visibleSubItems.map((subItem) => (
            <RenderItems
              key={subItem.menuId || subItem.path || subItem.title}
              item={subItem}
              isSidebarOpen={isSidebarOpen}
              closeSidebar={closeSidebar}
              forceShowSubItems={forceShowSubItems}
              depth={depth + 1}
            />
          ))}
        </s.SubItemsContainer>
      )}
    </>
  );
};

export default RenderItems;
